import { useNavigate } from "react-router-dom";

export function stringToEnum<T>(str: string, enumType: T): T[keyof T] | undefined {
    return enumType[str as keyof T];
}
